import RaceManageRacialTrait from './RaceManageRacialTrait';

export default RaceManageRacialTrait;
export { RaceManageRacialTrait };
